<script setup lang="ts">

import {useBaseStore} from "@/stores/base";
import {useApiClient} from "@/api/client";
import {computed, onBeforeUnmount, onMounted, ref, shallowRef, watch} from "vue";
import {showToaster, toastApiResult} from "@/toaster";

// Props
const visible = defineModel<boolean>("visible");

// Clients / stores
const store = useBaseStore();
const client = useApiClient("users");

// Refs
const otp = shallowRef<string>("");
const loading = shallowRef(false);
const loadingButton = shallowRef(false);
const lastTime = shallowRef<number | null>(null);
const timeoutId = shallowRef<number | null>(null);

async function submitCode() {
	loading.value = true;
	const response = await toastApiResult(client.sendCodeForPhone({
		phone_number: store.currentUser.phone_number,
		code: otp.value
	}));

	if (response.isOk()) {
		const response = await toastApiResult(client.updateProfile(store.currentUser));
		if (response.isOk()) {
			store.currentUser = response.value;
		}
	}

	loading.value = false;
	visible.value = false;
}

async function requestNewCode() {
	const now = Date.now();
	// TODO: Toaster, would be more subtle... but it's awful to use.
	if (lastTime.value && now - lastTime.value < 10_000) {
		alert("Please wait atleast 10 seconds before requesting a new code.");
		return;
	}

	await toastApiResult(client.verifyPhone({
		phone_number: store.currentUser.phone_number,
	}));

	loadingButton.value = false;
	loading.value = false;
	lastTime.value = now;
}

watch(visible, () => {
	if (visible.value) {
		loadingButton.value = true;
		timeoutId.value = setTimeout(() => requestNewCode(), 5000);
	} else if (!visible.value && timeoutId.value !== null) {
		clearTimeout(timeoutId.value); // Cancel the pending request for a new code...
	}
});

</script>

<template>
	<v-dialog v-model="visible" width="auto" persistent>
		<v-card
			max-width="400"
			prepend-icon="mdi-phone"
			title="Verification step"
			subtitle="We need you to verify your new phone number."
		>
			<v-divider/>
			<v-otp-input :loading="loading" v-model:model-value="otp"/>
			<div class="text-caption ma-auto mb-2">
				Didn't receive the code? <a href="#" @click.prevent="requestNewCode">Resend</a>
			</div>
			<v-divider/>
			<template v-slot:actions>
				<v-btn
					text="Cancel"
					color="red"
					:disabled="loading"
					@click="visible = false"
				></v-btn>
				<v-btn
					text="Ok"
					variant="tonal"
					:loading="loadingButton"
					:disabled="otp.length < 6 || loading === true"
					@click="submitCode"
				></v-btn>
			</template>
		</v-card>
	</v-dialog>
</template>

<style scoped lang="scss">

</style>
